import { Component, OnInit, OnDestroy, Input, TemplateRef, ViewChild, 
  ElementRef, AfterViewInit, SimpleChanges, OnChanges, EventEmitter, Output, ViewEncapsulation, 
  AfterViewChecked, ViewChildren, QueryList } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { fromEvent, Subject } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { GlobalEventsManagerService } from '../../../../../../job/common/services/global-events-manager.service';
import { UserService } from '../../../../../../services/user.service';
import { TranslateService } from '../../../../../../services/translate.service';
import { RessourcesService } from '../../../../../common/services/ressources.service';
import { WksCentralService } from '../../../../services/wks-central.service';
import { WksWorksService } from '../../../../services/wks-works.service';
import { ParamActionsrefModel, ParamLabelsI18n, TasksActionsModel, ParamWorksRatesModel, TasksActionsContentModel, 
      ParentTask, EventPartsSupplies, ParamPartsSuppliesModel, EventStatutCur, IhmOptions } from '../../../../models/wks-param.model';

import { WksEntityModel } from '../../../../models/wks-entity.model';
import { MeasurementList, DataUpstream } from '../../../../models/wks-common.model';
import { WksBusinessModel } from '../../../../models/wks-business.model';
import { LabelValue } from '../../../../../../models/data.model';
import { WksApisService } from '../../../../services/wks-apis.service';
import { CommonMethods } from '../../../../../..//job/common/tools/commonMethods';

@Component({
  selector: 'mdi-taskref-actions',
  templateUrl: './taskref-actions.component.html',
  styleUrls: ['./taskref-actions.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TaskrefActionsComponent implements OnInit, OnDestroy, AfterViewInit   {

  @Input() optionItem: any;
  @Input() actionType: any;
  @Input() parentParam: any;
  @Input() wksEntity: WksEntityModel;
  @Input() parentTask: ParentTask;
  @Input() rowTask: number;
  @Input() ihmOptions: IhmOptions;
  @Output() dataOut = new EventEmitter<EventStatutCur>();

  @ViewChild('filterActions', {static: false}) filterActions: ElementRef;
  @ViewChild('actionModal', {read: TemplateRef, static: false}) actionModal: TemplateRef<any>;
  @ViewChild('searchModal', {read: TemplateRef, static: false}) searchModal: TemplateRef<any>;

  // @ViewChildren('actionsLists') actionsLists!: QueryList<ElementRef>;
  
  private readonly onDestroy = new Subject<void>();

  worksReferenced: TasksActionsModel[];
  worksSelected: TasksActionsModel[];
  suppliesList: TasksActionsModel[];
  servicesList: TasksActionsModel[];

  worksSelectedCache: TasksActionsModel[];
  suppliesListCache: TasksActionsModel[];
  servicesListCache: TasksActionsModel[];


  rowEmpty: TasksActionsModel;
  cacheWorksList: TasksActionsModel[];
  toSelected = false;
  toReferenced = false;
  isAlreadyQuoted = false;
  isStockManagment = false;

  validOK = false;
  entityCur: string;
  isLoaded: boolean;
  listActionsCur: ParamActionsrefModel[];
  workCodeList: LabelValue[];
  unitsQuantity: LabelValue[];
  taskActionsList: LabelValue[];
  ownerCur: WksBusinessModel;
  worksRates: ParamWorksRatesModel[];
  scaleName: string;
  bsnDiscount: number;
  bsnCoef: number;

  modalRef: BsModalRef;
  configModal = {
    class: 'modal-dialog-centered modal-xl',
    backdrop: true,
    ignoreBackdropClick: true,
    animated: false,
  };
  typeSearch: string;
  dataUpstream: DataUpstream;
  intFormat: string ;
  numberFormat: {
    locale: string;
    minDecimal: string;
    maxDecimal: string;
    currency: string;
  };
  tasksActionsContentCache: TasksActionsContentModel;
  isReadOnly: boolean;

  constructor(private _translate: TranslateService, 
              private _userService: UserService, 
              private _ressourcesService: RessourcesService,
              private _wksCentralService: WksCentralService,
              private _globalEventsManagerService: GlobalEventsManagerService,
              private modalService: BsModalService,
              private _apisService: WksApisService,
              private _wksWorksService: WksWorksService) { }

  ngOnInit() {
    this.initData();
  }
  
  ngOnDestroy() {
    this.onDestroy.next();

  }
  ngAfterViewInit() {
    /*
    const nbHiden = this.worksReferenced.length;
    const nbDisplay = this.worksSelected.length;
    // const heigtRow = 35;
    let heigthCur = 35 * (nbHiden + nbDisplay);
    if ( heigthCur > 460) {
      heigthCur = 460;
    }
    if (this.optionItem === 'works') {
      document.getElementById('worksSelected').style.height = heigthCur.toString() + 'px';
      document.getElementById('worksReferenced').style.height = heigthCur.toString() + 'px';
      document.getElementById('columnCentral').style.height = heigthCur.toString() + 'px';
    }
*/
  }
  initData() {
    if (this._userService.getUserLogged() === undefined ) { return; }

    this.initAllBooleans();
    this.initAllParams();
    this.initAllSubscribes();
    this.settingFormats();
    
  }
  initAllBooleans() {
    this.isLoaded = false;  
    this.toReferenced = false;
    this.toSelected = false;
    this.isStockManagment = false;
    this.isReadOnly = false;
  }
  initAllParams()  {
    this.worksReferenced = [];
    this.worksSelected = [];
    this.suppliesList = [];
    this.servicesList = [];

    this.cacheWorksList = [];
    this.entityCur = this._userService.getUserLogged().entity;   
    this.rowEmpty = {
      ranking: 0,
      brandRef: '',
      actionrefId: '',
      actionrefLabel: '',
      billingUnit: '',
      quantity: 0.0,
      unitPrice: 0.0,
      extPrice: 0,
      comment: '',
      quoted: null,
      invoiced: null,
      status: null,
      available: false,
    };
    if (this.ihmOptions) {
      this.isReadOnly = this.ihmOptions.readOnly;
    }

    const countryEntity  = this._ressourcesService.getCountry(this._userService.getUserLogged().entitycountry);
    const isMetric = (countryEntity.measurementUnit === 'METRIC');
    const jsonUnits = this._wksCentralService.getUnitsQuantity() as MeasurementList[];
    let measurementLocal = 'METRIC';
    if (!isMetric) {
      measurementLocal = 'NON_METRIC';
    }
    this.isStockManagment = this._apisService.getApiStockManagement() !== undefined ? true : false;
    // tires
    this.unitsQuantity  = [];
    for (const measurLocal of jsonUnits) {
      if (measurLocal.measurement === measurementLocal) {
        const arrayUnits = [...measurLocal.list];
        for (const unitName of arrayUnits) {

          this.unitsQuantity.push({
            label: this._translate.getTranslate(unitName),
            value: unitName
          });
        }
        this.unitsQuantity.splice(0, 0, {
          label: '',
          value: ''
        });
        break;
      }
    }
    this.taskActionsList  = [];
    const jsonTaskActions = this._wksCentralService.getTaskActions() as string[];
    for (const actionTask of jsonTaskActions) {
      this.taskActionsList.push({
        label: this._translate.getTranslate(actionTask),
        value: actionTask
      });
    }

    if (this.actionType === 'withprice') {
      this.ownerCur = this._wksWorksService.getOwner();
      let accounting: any;
      if (this.ownerCur.bsnAccounting.bsnAccount === undefined) {
        accounting = JSON.parse(this.ownerCur.bsnAccounting);
      } else {
        accounting = this.ownerCur.bsnAccounting;
      }

      this.scaleName = (accounting.scaleName ? accounting.scaleName : 'PUBLIC');

      this.bsnDiscount = (accounting.bsnDiscount ? accounting.bsnDiscount : 0.0);
      this.bsnCoef = (accounting.bsnCoef ? accounting.bsnCoef : 1.0);
    }
    this.getParamWorksRefList()
    .then (actionsRead  => {
      // let rankCur = 0;
      this.initWorksReferencedList();
      this.initDisplayElements();
      this.isLoaded = true;

    })
    .catch(error  => {
      console.log(error);
      return;
    });
    const nbHiden = this.worksReferenced.length;
    const nbDisplay = this.worksSelected.length;
    // const heigtRow = 35;
    let heigthCur = 35 * (nbHiden + nbDisplay);
    if ( heigthCur > 460) {
      heigthCur = 460;
    } 
  }
  initAllSubscribes() {

    this._globalEventsManagerService.synchroEvents
    .pipe(takeUntil(this.onDestroy))
    .subscribe( event => {
      if (event === 'closeActionModal') {
        this.closeModal();
        // this.loadDocs();
      } else if (event === 'closeRegisterActionModal') {
        this.closeModal();
        this.getParamWorksRefList()
        .then (actionsRead  => {
          // let rankCur = 0;
          this.initWorksReferencedList();
        })
        .catch(error  => {
          console.log(error);
          return;
        });
      } else if (event) {
        const typeEvent = typeof event;
        const eventString = String(event);
        // console.log(typeEvent);
      }
    });
  }

  settingFormats() {
    const otherData = JSON.parse(this.wksEntity.otherData);
    this.intFormat = otherData.internationnalFormat;
    this.numberFormat = { 
      locale: this._ressourcesService.getFormat(this.intFormat, 'numbers', 'locale'),
      minDecimal: this._ressourcesService.getFormat(this.intFormat, 'numbers', 'minimumFractionDigits'),
      maxDecimal: this._ressourcesService.getFormat(this.intFormat, 'numbers', 'maximumFractionDigits'),
      currency:  this._ressourcesService.getFormat(this.intFormat, 'numbers', 'currency'),
    };
  }
  initWorksReferencedList() {
    this.cacheWorksList = [];
    this.worksReferenced = [];
    for (const actionReading of this.listActionsCur)  {
      const jsonWorkPricing = JSON.parse(actionReading.paramWorksRates.workPricing);
      const workCur:  TasksActionsModel = {
        brandRef: actionReading.brandRef,
        actionrefId: actionReading.actionrefId,
        actionrefLabel: this.translateWorkRef(actionReading),
        billingUnit: this._translate.getTranslate(actionReading.billingUnit.trim()),
        unitPrice: jsonWorkPricing[0].scaleRate,
        workCode: actionReading.workCode,
        selected: false,
      };
      this.worksReferenced.push(workCur);
      this.cacheWorksList.push(workCur);
    }
    if (this.worksReferenced.length > 0) {
      this.worksReferenced.sort(function(obj1, obj2) {
        return obj1.actionrefLabel > obj2.actionrefLabel ? 1 : -1;
      });
    if (this.worksReferenced.length > 0) { 
      const blankItem:  TasksActionsModel = {
        brandRef: '',
        actionrefId: '',
        actionrefLabel: '',
        billingUnit: '',
        unitPrice: undefined,
        workCode: '',
        selected: false,
      };
      this.worksReferenced.unshift(blankItem);
    }
      this.toSelected = true;
      // this.cacheWorksList = [...this.worksReferenced];
    } else {
      // this.toReferenced = true;
      
    }
    if (this.worksSelected.length === 0) {
      // this.toSelected = true;
    } else {
      // prendre le dernier prix si non readOnly
      if (!this.isReadOnly) {
        for ( const itemWorkSelected of this.worksSelected) {
          for (const itemWorkReferenced of this.worksReferenced) {
            if (itemWorkReferenced.actionrefId === itemWorkSelected.actionrefId ) {
              itemWorkSelected.unitPrice = itemWorkReferenced.unitPrice;
              if ((itemWorkSelected.quantity !== undefined) && ( Number(itemWorkSelected.quantity) > 0) ) {
                itemWorkSelected.extPrice = itemWorkSelected.unitPrice *  Number(itemWorkSelected.quantity);
              } else {
                itemWorkSelected.extPrice = 0.0;
              }
            }
          }
        }
      }
      this.worksSelected.sort(function(obj1, obj2) {
        return obj1.ranking > obj2.ranking ? 1 : -1;
      });
      if (this.worksSelected.length > 0) { 
        const blankItem:  TasksActionsModel = {
          brandRef: '',
          actionrefId: '',
          actionrefLabel: '',
          billingUnit: '',
          unitPrice: undefined,
          workCode: '',
          selected: false,
        };
        this.worksSelected.unshift(blankItem);
      }
      this.toReferenced = true;
    }
  }
  getParamWorksRefList() {
    return new Promise((resolve, reject) => {
      this._wksCentralService.getParamWorksRefList(this._userService.getUserLogged().entity, this._userService.getUserLogged().userlang)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          const worksRead = data.body as ParamActionsrefModel[];
          this.listActionsCur = [...this.translateWorksRef(worksRead)];
          resolve(worksRead);
        },
        err => {
          console.log(err);
          reject(err.status);
        }
      );
    });
  }
  /*
  loadWorksType() {
    let dataReturn: ParamWorksRatesModel[];
    this.workCodeList = [];
    return new Promise((resolve, reject) => {
      this._wksCentralService.getWksWorkRatesList(this._userService.getUserLogged().entity, this._userService.getUserLogged().userlang)
     .pipe(takeUntil(this.onDestroy))
     .subscribe(
       data => {
          dataReturn = data.body;
          this.worksRates = dataReturn;
          for (const workCur of dataReturn) {
            const workLabelCur: LabelValue = {
              label: workCur.workLabel,
              value: workCur.workCode
            };
            this.workCodeList.push(workLabelCur);
          }
          this.workCodeList.sort((obj1: LabelValue, obj2: LabelValue) => {
            return obj1.label > obj2.label ? 1 : -1;
          });
          this.workCodeList.splice(0, 1, {
            label: this._translate.getTranslate('all jobs type'),
            value: 'all jobs type',
          });
          resolve(dataReturn) ;
        }, err => {
          console.log(err);
          reject(err.status);
        }
      );
    });
  }
    */
   /*
  onChangeWork($event: any) {
    this.worksReferenced = [];
    this.cacheWorksList = [];
       
    for (const actionReading of this.listActionsCur)  {
      if ((actionReading.workCode === $event) || ('all jobs type' === $event)) {
        const jsonWorkPricing = JSON.parse(actionReading.paramWorksRates.workPricing);
        const workCur:  TasksActionsModel = {
          brandRef: actionReading.brandRef,
          actionrefId: actionReading.actionrefId,
          actionrefLabel: this.translateWorkRef(actionReading),
          billingUnit: this._translate.getTranslate(actionReading.billingUnit.trim()),
          unitPrice: jsonWorkPricing[0].scaleRate,
          workCode: actionReading.workCode,
          selected: false,
        };
        this.worksReferenced.push(workCur);
        this.cacheWorksList.push(workCur);
      }
    }
    if (this.worksReferenced.length > 0) {
      this.worksReferenced.sort(function(obj1, obj2) {
        return obj1.actionrefLabel > obj2.actionrefLabel ? 1 : -1;
      });
      if (this.worksSelected.length > 0 ) {      
        for (const actionSel of this.worksSelected) {
          let numRow = 0;
          for ( const actionRef of this.worksReferenced) {
            if (actionRef.actionrefId === actionSel.actionrefId) {
              this.worksReferenced.splice(numRow, 1);

              if ((actionSel.quantity !== undefined) && ( Number(actionSel.quantity) > 0) ) {
                actionSel.extPrice = actionSel.unitPrice *  Number(actionSel.quantity);
              } else {
                actionSel.extPrice = 0.0;
              }
              break;
            }
            numRow++;
          }
        }
      }
      this.toSelected = true;
    } else {
      // this.initWorksReferencedList();
    }
  }
    */
  translateWorksRef(actionsCur: ParamActionsrefModel[]): ParamActionsrefModel[] {
    const localArray:  ParamActionsrefModel[] = [];
    for (const localData of actionsCur ) {
      let langLabels: ParamLabelsI18n[];
      
      langLabels = localData.langLabels;
      if (langLabels !== null ) {
        for (const langLabel of langLabels) {
          if (langLabel.labelLang === this._translate.getCurrentLang()) {
            localData.actionrefLabel =  langLabel.labelText;
            break;
          }
        }
      }
      localArray.push(localData);
    }
    return localArray;
  }
  translateWorkSelected(tasksAction: TasksActionsModel): string {
    let actionLabel = '';
    for (const actionCur of this.listActionsCur) {
      if (actionCur.actionrefId === tasksAction.actionrefId) {
        actionLabel = this.translateWorkRef(actionCur);
        break;
      }
    }
    return actionLabel;
  }
  translateWorkRef(actionsCur: ParamActionsrefModel): string {
    const langLabels = actionsCur.langLabels;
    let localLabel = '';
    if (langLabels !== null ) {
      for (const langLabel of langLabels) {
        if (langLabel.labelLang === this._translate.getCurrentLang()) {
          localLabel =  langLabel.labelText;
          break;
        }
      }
    }
    return localLabel;
  }
  referencedToSelected(actionrefId: string, idxRow: number) {

    let rankCur = 0;
    for (const actionReading of this.worksReferenced)  {
      if (actionReading.actionrefId === actionrefId) {
        rankCur++;
        actionReading.ranking = rankCur;
        actionReading.unitPrice =  actionReading.unitPrice;
        actionReading.extPrice = 0.0;
        actionReading.quantity = 0.0;
        this.worksSelected[idxRow] = actionReading;
        break;
      }
    }
    this.settingValues('works', true, 2000);
    this.registerActions('works', false);
  }
  /*
  onKeyFilterWorks($event: any) {
    // console.log(value);
    if ($event === '' ) {
      this.worksReferenced = [...this.cacheWorksList];
      return;
    }
    let valueFinal = $event.target.value;
    if ( $event.keyCode === 32) {
      valueFinal += ' ';
    }
    this.worksReferenced = this.searchActions(valueFinal);
    this.filterActions.nativeElement.value = valueFinal;
  }
  searchActions(value: string) { 
    const filter = value.toLowerCase();
    return this.worksReferenced.filter(actionCur => actionCur.actionrefLabel.toLowerCase().includes(filter));
  }
 
  referencedToSelected(arg: string) {

    // this.worksSelected = [];
    let rankCur = 0;
    if (this.worksSelected.length > 0) {
      rankCur = this.worksSelected.length;
    }
    if (arg === 'checked') {
      let idxSelected = 0;
      const cacheReferenced = [...this.worksReferenced];
      for (const actionReading of this.worksReferenced)  {
        
        if (actionReading.selected) {
          rankCur++;
          actionReading.ranking = rankCur;
          // actionReading.unitPrice =  this.getWorkRate(actionReading.workCode);
          actionReading.extPrice = 0.0;
          actionReading.quantity = 0.0;
          this.worksSelected.push(actionReading);
          cacheReferenced.splice(idxSelected, 1);
          idxSelected--;
        }
        idxSelected++;
      }
      this.worksReferenced = [];
      this.worksReferenced = [...cacheReferenced];
      if (this.worksReferenced.length === 0) {
        this.toSelected = false;
      }
      if (this.worksSelected.length > 0) {
        this.toReferenced = true;
      }
      this.settingValues('works', true)
      this.registerActions('works', false);
      return;
    }
 

    for (const actionReading of this.worksReferenced)  {
      rankCur++;
      actionReading.ranking = rankCur;
      
      this.worksSelected.push(actionReading);
    }
    this.worksReferenced = [];
    this.toSelected = false;
    this.toReferenced = true;
    this.settingValues('works', true)
    this.registerActions('works', false);
  }
  selectedToReferenced() {
    this.worksReferenced = [];
    this.worksSelected = [];
    this.initWorksReferencedList();
    this.toSelected = true;
    this.toReferenced = false;
    this.registerActions('works', false);
  }
 drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer !== event.container) {
      transferArrayItem(event.previousContainer.data, event.container.data, 
        event.previousIndex, event.currentIndex);
    } else {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

    } 
    let listActions: any[];
    if (event.container.id === 'worksSelected') {
      this.worksSelected[event.currentIndex].ranking = event.currentIndex + 1;
      this.worksSelected[event.currentIndex].selected = true;
      listActions = event.container.data ;
      this.registerActions('works', false);
    } else {
      this.worksReferenced[event.currentIndex].selected = false;
      listActions = event.previousContainer.data ;
      this.registerActions('works', false);
    }
    // ranking calcul
    let idx = -1;
    for (const curRow of listActions) {

      idx++;
      for (const actionsList of this.worksSelected) {
        if (actionsList.quoted === undefined) {
          actionsList.quoted = null;
          actionsList.invoiced = null;
          actionsList.status = null;
        }
        if (curRow.actionrefId === actionsList.actionrefId) {
          actionsList.ranking = idx + 1;
          // actionsList.unitPrice =  this.getWorkRate(actionsList.workCode);
        }
      }
    }
    if (this.worksReferenced.length > 0) {
      this.toSelected = true;
      this.worksReferenced.sort(function(obj1, obj2) {
        return obj1.actionrefLabel > obj2.actionrefLabel ? 1 : -1;
      });
    } else {
      this.toReferenced = true;
      this.toSelected = false;
    }
    if (this.worksSelected.length > 0) {
      this.toReferenced = true;
      

    } else {
      this.toReferenced = false;
      this.toSelected = true;
      
    }

  }
  
  checkChange(fieldChecked: string, inputValue: any, index: number) {
    if (fieldChecked === 'checked') {
      this.toSelected = true;
      this.worksReferenced[index].selected = inputValue;
    }

  }
    */
  getPartsAvailaible(): void {
    this.getTaskStockAvailaible()
    .then (actionsRead  => {
      // let rankCur = 0;
    })
    .catch(error  => {
      console.log(error);
      return;
    });
  }
  getTaskStockAvailaible() {
    return new Promise((resolve, reject) => {
      this._wksCentralService.getTaskStockAvailaible(this._userService.getUserLogged().entity, this.suppliesList)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          this.suppliesList = data.body as TasksActionsModel[];

          this.settingValues('supplies&parts', true, 1000);
          resolve('OK');
        },
        err => {
          console.log(err);
          reject(err.status);
        }
      );
    });
  }
  getPartsPrices(): void {

    this.getStockPartsPrices()
    .then (actionsRead  => {
      // let rankCur = 0;
    })
    .catch(error  => {
      console.log(error);
      return;
    });
  }
  getStockPartsPrices() {
    return new Promise((resolve, reject) => {
      this._wksCentralService.getUnitPricesStock(this._userService.getUserLogged().entity, this.suppliesList)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          this.suppliesList = data.body as TasksActionsModel[];
          let idxRow = 0 ;
          for ( const itemSupplie of this.suppliesList) {
            itemSupplie.extPrice = itemSupplie.unitPrice *  Number(itemSupplie.quantity);
            // this.setChangeValuesSupplies('unitPrice', itemSupplie.unitPrice, idxRow);
            idxRow++;
          }
          this.settingValues('supplies&parts', true, 1000);
          resolve('OK');
        },
        err => {
          console.log(err);
          reject(err.status);
        }
      );
    });
  }
  addServices(index: number) {
    this.openSearchModal('services');
  }
  addSupplies(index: number) {
    this.openSearchModal('supplies&parts');
  }
  addWork(index: number) {
    this.worksSelected.push(this.rowEmpty);
  }
  removeWork(index: number) { 
    this.worksSelected.splice(index, 1);
    this.registerActions('works', false);
  }
  addListSuppliesModal($event: any) {
    this.closeModal();
    if (typeof($event) === 'string') {
      if ($event === 'cancel') {
        return;
      }
    }
    if (this.optionItem === 'services' ) {
      this.addListServices($event);
    } else  {
      this.addListSupplies($event);
    }
  }
  addListServices(partsSupplies: ParamPartsSuppliesModel[]) {
    for (const partSupplieCur of partsSupplies) {
      let isFound = false;
      for (const supplieExists of this.servicesList) {
        if (supplieExists.partSupplieId === partSupplieCur.id) {
          isFound = true;
          break;
        }
      }
      if (isFound) {
        isFound = false;
        continue;
      }
      const serviceCur = {
        ranking: 0,
        brandRef: partSupplieCur.brandRef,
        partSupplieId: partSupplieCur.id,
        actionrefLabel: partSupplieCur.partsSuppliesLabel,
        billingUnit: partSupplieCur.paramUnit,
        quantity: 0.0,
        unitPrice: partSupplieCur.paramRates[0].paramRate,
        extPrice: 0,
        comment: '',
        quoted: null,
        invoiced: null,
        status: null,
        available: false,
        parentElement: false
      };
      this.servicesList.push(serviceCur);

    }
    this.settingValues('services', true, 1000);
    this.registerActions('services', false);
  }
  removeServices(index: number) { 

    this.servicesList.splice(index, 1);
    this.registerActions('services', false);
  }
  addListSupplies(partsSupplies: ParamPartsSuppliesModel[]) {
    for (const partSupplieCur of partsSupplies) {
      let isFound = false;
      for (const supplieExists of this.suppliesList) {
        if (supplieExists.partSupplieId === partSupplieCur.id) {
          isFound = true;
          break;
        }
      }
      if (isFound) {
        isFound = false;
        continue;
      }
      const supplieCur = {
        ranking: 0,
        brandRef: partSupplieCur.brandRef,
        partSupplieId: partSupplieCur.id,
        actionrefLabel: partSupplieCur.partsSuppliesLabel,
        billingUnit: partSupplieCur.paramUnit,
        quantity: 0.0,
        unitPrice: 0.0,
        extPrice: 0,
        comment: '',
        quoted: null,
        invoiced: null,
        status: null,
        available: false,
        parentElement: false
      };
      this.suppliesList.push(supplieCur);

    }
    this.settingValues('supplies&parts', true, 1000);
    this.registerActions('supplies&parts', false);
  }
  removeSupplies(index: number) { 
  
    this.suppliesList.splice(index, 1);
    this.registerActions('supplies&parts', false);
  }

  onChangeUnitQuantity($event: any, index: number) {
 
    this.suppliesList[index].billingUnit = $event.source.value;
    this.registerActions('supplies&parts', false);
  }
  onChangeActionTask($event: any, index: number) {
 
    this.suppliesList[index].actionTask = $event.source.value;
    this.registerActions('supplies&parts', false);
  }
  setChangeValuesSupplies(_typeInput: string, inputValue: any, index: number) {
    switch (_typeInput) {
      case 'actionrefLabel':
        this.suppliesList[index].actionrefLabel = inputValue;
        break;
      case 'brandRef':
        this.suppliesList[index].brandRef = inputValue;
        break;
      case 'quantity':
        this.suppliesList[index].quantity = inputValue;
        if (this.suppliesList[index].unitPrice) {
          this.suppliesList[index].extPrice = this.suppliesList[index].unitPrice  *  Number(this.suppliesList[index].quantity);
        }
        // JLG 2026-02-22
        // this.settingValues(this.optionItem, false, 500);
        break;
      case 'unitPrice':
        this.suppliesList[index].unitPrice = inputValue;
        if (this.suppliesList[index].quantity) {
          this.suppliesList[index].extPrice = this.suppliesList[index].unitPrice  *  Number(this.suppliesList[index].quantity);
        }
        // JLG 2026-02-22
        // this.settingValues(this.optionItem, false, 500);
        break;
      case 'available':
        this.suppliesList[index].available = inputValue;
        break;
    }
    this.registerActions('supplies&parts', false);
  }
  setChangeValuesServices(_typeInput: string, inputValue: any, index: number) {
    switch (_typeInput) {
      case 'actionrefLabel':
        this.servicesList[index].actionrefLabel = inputValue;
        break;
      case 'brandRef':
        this.servicesList[index].brandRef = inputValue;
        break;
      case 'billingUnit':
        this.servicesList[index].billingUnit = inputValue;
        break;
      case 'quantity':
        this.servicesList[index].quantity = inputValue;
        if (this.servicesList[index].unitPrice) {
          this.servicesList[index].extPrice = this.servicesList[index].unitPrice  *  Number(this.servicesList[index].quantity);
        }
        break;
      case 'unitPrice':
        this.servicesList[index].unitPrice = inputValue;
        if (this.servicesList[index].quantity) {
          this.servicesList[index].extPrice = this.servicesList[index].unitPrice  *  Number(this.servicesList[index].quantity);
        }
        break;
    }
    this.registerActions('services', false);
  }
  setChangeValuesWorks(_typeInput: string, inputValue: any, index: number) {
    switch (_typeInput) {
      case 'actionrefLabel':
        this.worksSelected[index].actionrefLabel = inputValue;
        break;
      case 'brandRef':
        this.worksSelected[index].brandRef = inputValue;
        break;
      case 'billingUnit':
        this.worksSelected[index].billingUnit = inputValue;
        break;
      case 'quantity':
        this.worksSelected[index].quantity = inputValue;
        if (this.worksSelected[index].unitPrice) {
          this.worksSelected[index].extPrice = this.worksSelected[index].unitPrice  *  Number(this.worksSelected[index].quantity);
        }
        break;
      case 'unitPrice':
        this.worksSelected[index].unitPrice = inputValue;
        if (this.worksSelected[index].quantity) {
          this.worksSelected[index].extPrice = this.worksSelected[index].unitPrice  *  Number(this.worksSelected[index].quantity);
        }
        break;
    }
    this.registerActions('works', false);
  }
  numberAndDotOnly(event: any): boolean {
    return CommonMethods.numberAndDotOnly(event);
  }
  formatNumericInput(fieldType: string, fieldOrig: string, fieldName: string, index: number): void {
    switch (fieldType) {
      case 'supplies': {
        switch (fieldOrig) {
          case 'quantity': {
            this.suppliesList[index].quantity = CommonMethods.getNumericValue(fieldName);
            // this.settingValues(fieldType);
            this.registerActions(fieldType, false);
            break;
          }
        }
        break;
      }
      case 'services': {
        switch (fieldOrig) {
          case 'quantity': {
            this.servicesList[index].quantity = CommonMethods.getNumericValue(fieldName);
            this.settingValues(fieldType);
            this.registerActions(fieldType, false);
            break;
          }
        }
        break;
      }
      case 'works': {
        switch (fieldOrig) {
          case 'quantity': {
            this.worksSelected[index].quantity = CommonMethods.getNumericValue(fieldName);
            this.settingValues(fieldType);
            this.registerActions(fieldType, false);
            break;
          }
        }
        break;
      }
    }  
  }
  formatCurrencyInput(fieldType: string, fieldOrig: string, fieldName: string, index: number): void {

    switch (fieldType) {
      case 'supplies': {
        switch (fieldOrig) {
          case 'unitPrice': {
            this.suppliesList[index].unitPrice = CommonMethods.getNumericValue(fieldName);
            // this.settingValues(fieldType);
            this.registerActions(fieldType, false);
            break;
          }
          case 'extPrice': {
            this.suppliesList[index].extPrice = CommonMethods.getNumericValue(fieldName);
            this.settingValues(fieldType);
            this.registerActions(fieldType, false);
            break;
          }
        }
        break;
      }
      case 'services': {
        switch (fieldOrig) {
          case 'unitPrice': {
            this.servicesList[index].unitPrice = CommonMethods.getNumericValue(fieldName);
            this.settingValues(fieldType);
            this.registerActions(fieldType, false);
            break;
          }
          case 'extPrice': {
            this.servicesList[index].extPrice = CommonMethods.getNumericValue(fieldName);
            this.settingValues(fieldType);
            this.registerActions(fieldType, false);
            break;
          }
        }
        break;
      }
      case 'works': {
        switch (fieldOrig) {
          case 'unitPrice': {
            this.worksSelected[index].unitPrice = CommonMethods.getNumericValue(fieldName);
            this.settingValues(fieldType);
            this.registerActions(fieldType, false);
            break;
          }
          case 'extPrice': {
            this.worksSelected[index].extPrice = CommonMethods.getNumericValue(fieldName);
            this.settingValues(fieldType);
            this.registerActions(fieldType, false);
            break;
          }
        }
        break;
      }
    }

  }
  initDisplayElements() {
    this.isAlreadyQuoted = false;
    if (this.optionItem === 'works') {
      if (this.parentParam !== undefined && this.parentParam.length > 0 ) {
        this.worksSelected = this.parentParam;
        for (const actionSel of this.worksSelected) {
          let numRow = 0;
          if ((actionSel.quoted !== undefined) && (actionSel.quoted != null)) {
            this.isAlreadyQuoted = true;
          }
          actionSel.actionrefLabel = this.translateWorkSelected(actionSel);
          for ( const actionRef of this.worksReferenced) {
            if (actionRef.actionrefId === actionSel.actionrefId) {
              // this.worksReferenced.splice(numRow, 1);
              if (!this.isReadOnly) {
                actionSel.unitPrice = actionRef.unitPrice;
              }
              if ((actionSel.quantity !== undefined) && ( Number(actionSel.quantity) > 0) ) {
                let calculatePrice = false;
                if (actionSel.extPrice === null || actionSel.extPrice === undefined ) {
                  calculatePrice = true;
                }
                actionSel.extPrice = actionSel.unitPrice *  Number(actionSel.quantity);
                const eventNum = Number.isNaN(actionSel.extPrice);
                if (calculatePrice && !eventNum ) {
                  // this.registerActions('works', true);
                  calculatePrice = false;
                }
              } else {
                actionSel.extPrice = 0.0;
              }
              break;
            }
            numRow++;
          }
        }
        if (this.worksSelected.length > 0) {
          this.worksSelected.sort(function(obj1, obj2) {
            return obj1.ranking > obj2.ranking ? 1 : -1;
          });
          this.toReferenced = true;
        }
      } else {
        this.worksSelected = [];
      }
      this.settingValues(this.optionItem, true);
      this.worksSelectedCache = JSON.parse(JSON.stringify(this.worksSelected));
      // this.registerActions('works', false);
    }
    if (this.optionItem === 'supplies&parts') {
      if (this.parentParam !== undefined  && this.parentParam.length > 0 ) {
        this.suppliesList = [];
        for (const supplieTmp of this.parentParam) {
          supplieTmp.taskParent = true;
          this.suppliesList.push(supplieTmp);
        }
        // this.settingValues(this.optionItem, true );
      } else {
        this.suppliesList = [];
      }
      this.suppliesListCache = JSON.parse(JSON.stringify(this.suppliesList)) ;
      // this.registerActions('supplies&parts', false);
    }
    if (this.optionItem === 'services') {
      if (this.parentParam !== undefined  && this.parentParam.length > 0 ) {
        this.servicesList = [];
        for (const serviceTmp of this.parentParam) {
          serviceTmp.taskParent = true;
          this.servicesList.push(serviceTmp);
        }
      } else {
        this.servicesList = [];
      }

      this.settingValues(this.optionItem, true);
      this.servicesListCache = JSON.parse(JSON.stringify(this.servicesList));
      // this.registerActions('services', false);
    }
  }
  // @deprecated (JLG- 2o26-03-04)
  settingValues(optionItem: string, isTimeOut?: boolean, waitingTime?: number): void {
    // timeout pour le premier affichage : les champs n'existent pas et ne sont pas accessibles immédiatement.
    if (waitingTime === undefined) {
      waitingTime = 3000;
    }
    switch (optionItem) {
      case 'services':
        if (isTimeOut) {
          setTimeout(() => {
            this.settingServicesValues();
          }, waitingTime); // 3000 ms = 3 secondes
        } else  {
          try {
            this.settingServicesValues();
          } catch {
            setTimeout(() => {
              this.settingServicesValues();
            }, waitingTime); // 3000 ms = 3 secondes
          }
        }
        break;
      case 'works':
        if (isTimeOut) {
          setTimeout(() => {
            this.settingWorksValues();
          }, waitingTime); // 3000 ms = 3 secondes
        } else  {
          try {
            this.settingWorksValues();
          } catch {
            setTimeout(() => {
              this.settingWorksValues();
            }, waitingTime); // 3000 ms = 3 secondes
          }
        }
        break;
      case 'supplies&parts' :
        if (isTimeOut) {
          setTimeout(() => {
            this.settingSuppliesValues();
          }, waitingTime); // 3000 ms = 3 secondes
        } else  {
          try {
            this.settingSuppliesValues();
          } catch {
            setTimeout(() => {
              this.settingSuppliesValues();
            }, waitingTime); // 3000 ms = 3 secondes
          }
        }
        break;
      case 'supplies' :
        if (isTimeOut) {
          setTimeout(() => {
            this.settingSuppliesValues();
          }, waitingTime); // 3000 ms = 3 secondes
        } else  {
          try {
            this.settingSuppliesValues();
          } catch {
            setTimeout(() => {
              this.settingSuppliesValues();
            }, waitingTime); // 3000 ms = 3 secondes
          }
        }
        break;
    }
  }
  // @deprecated (JLG- 2o26-03-04)
  settingServicesValues(): void {
    let idxItem = 0;
    for (const serviceCur of this.servicesList) {
      const quantityField = 'services_quantity_' + idxItem;
      const unitPriceField = 'services_unitPrice_' + idxItem;
      const extPriceField = 'services_extPrice_' + idxItem;
      let input = document.getElementById(quantityField) as HTMLInputElement;
      input.value = '' + serviceCur.quantity;
      this.formatNumericField('services', 'quantity', quantityField, idxItem);
      input = document.getElementById(unitPriceField) as HTMLInputElement;
      input.value = '' + serviceCur.unitPrice;
      this.formatCurrencyField('services', 'unitPrice', unitPriceField, idxItem);
      input = document.getElementById(extPriceField) as HTMLInputElement;
      input.value = '' + serviceCur.extPrice;
      this.formatCurrencyField('services', 'extPrice', extPriceField, idxItem);
      idxItem++;
    }
  }
  // @deprecated (JLG- 2o26-03-04)
  settingWorksValues(): void {
    let idxItem = 0;
    for (const workCur of this.worksSelected) {
      const quantityField = 'works_quantity_' + idxItem;
      const unitPriceField = 'works_unitPrice_' + idxItem;
      const extPriceField = 'works_extPrice_' + idxItem;
      let input = document.getElementById(quantityField) as HTMLInputElement;
      input.value = '' + workCur.quantity;
      this.formatNumericField('works', 'quantity', quantityField, idxItem);
      input = document.getElementById(unitPriceField) as HTMLInputElement;
      input.value = '' + workCur.unitPrice;
      this.formatCurrencyField('works', 'unitPrice', unitPriceField, idxItem);
      input = document.getElementById(extPriceField) as HTMLInputElement;
      input.value = '' + workCur.extPrice;
      this.formatCurrencyField('works', 'extPrice', extPriceField, idxItem);
      idxItem++;
    }
  }
  // @deprecated (JLG- 2o26-03-04)
  settingSuppliesValues(): void {
    let idxItem = 0;
    for (const supplieCur of this.suppliesList) {
      const quantityField = 'supplies_quantity_' + idxItem;
      const unitPriceField = 'supplies_unitPrice_' + idxItem;
      const extPriceField = 'supplies_extPrice_' + idxItem;
      let input = document.getElementById(quantityField) as HTMLInputElement;
      input.value = '' + supplieCur.quantity;
      this.formatNumericField('supplies', 'quantity', quantityField, idxItem);
      input = document.getElementById(unitPriceField) as HTMLInputElement;
      input.value = '' + supplieCur.unitPrice;
      this.formatCurrencyField('supplies', 'unitPrice', unitPriceField, idxItem);
      input = document.getElementById(extPriceField) as HTMLInputElement;
      input.value = '' + supplieCur.extPrice;
      this.formatCurrencyField('supplies', 'extPrice', extPriceField, idxItem);
      idxItem++;
    }
  }
  // @Deprecated 'JLG - 2026-03-03)
  formatNumericField(fieldType: string, fieldOrig: string, fieldName: string, index: number): void {
  
    switch (fieldType) {
      case 'supplies': {
        switch (fieldOrig) {
          case 'quantity': {
            this.suppliesList[index].quantity = CommonMethods.getNumericValue(fieldName);
            this.suppliesList[index].extPrice = this.suppliesList[index].unitPrice *  Number(this.suppliesList[index].quantity);
            this.registerActions('supplies&parts', false);
            CommonMethods.formatNumericField(fieldName, this._translate, 
              ['quantity', this.numberFormat.locale, this.numberFormat.minDecimal, this.numberFormat.maxDecimal]);
            break;
          }
        }
        break;
      }
      case 'services': {
        switch (fieldOrig) {
          case 'quantity': {
            this.servicesList[index].quantity = CommonMethods.getNumericValue(fieldName);
            this.servicesList[index].extPrice = this.servicesList[index].unitPrice *  Number(this.servicesList[index].quantity);
            this.registerActions('services', false);
            CommonMethods.formatNumericField(fieldName, this._translate, 
              ['quantity', this.numberFormat.locale, this.numberFormat.minDecimal, this.numberFormat.maxDecimal]);
            break;
          }
        }
        break;
      }
      case 'works': {
        switch (fieldOrig) {
          case 'quantity': {
            this.worksSelected[index].quantity = CommonMethods.getNumericValue(fieldName);
            this.worksSelected[index].extPrice = this.worksSelected[index].unitPrice * Number(this.worksSelected[index].quantity);
            this.worksSelected[index].available = true;
            this.registerActions('works', false);
            CommonMethods.formatNumericField(fieldName, this._translate, 
              ['quantity', this.numberFormat.locale, this.numberFormat.minDecimal, this.numberFormat.maxDecimal]);
            break;
          }
        }
        break;
      }
    }        
  }
  unformatNumeric(fieldType: string, fieldOrig: string, fieldName: string, index: number): void {
    switch (fieldType) {
      case 'supplies': {
        switch (fieldOrig) {
          case 'quantity': {
            this.suppliesList[index].quantity = 0;
            // CommonMethods.unformatNumericField(fieldName);
            break;
          }
          case 'unitPrice': {
            this.suppliesList[index].unitPrice = 0;
            // CommonMethods.unformatNumericField(fieldName);
            break;
          }
          case 'extPrice': {
            this.suppliesList[index].extPrice = 0;
            // CommonMethods.unformatNumericField(fieldName);
            break;
          }
        }
        break;
      }
      case 'services': {
        switch (fieldOrig) {
          case 'quantity': {
            this.servicesList[index].quantity = 0;
            // CommonMethods.unformatNumericField(fieldName);
            break;
          }
          case 'unitPrice': {
            this.servicesList[index].unitPrice = 0;
            // CommonMethods.unformatNumericField(fieldName);
            break;
          }
          case 'extPrice': {
            this.servicesList[index].extPrice = 0;
            // CommonMethods.unformatNumericField(fieldName);
            break;
          }
        }
        break;
      }
      case 'works': {
        switch (fieldOrig) {
          case 'quantity': {
            this.worksSelected[index].quantity = 0;
            // CommonMethods.unformatNumericField(fieldName);
            break;
          }
          case 'unitPrice': {
            this.worksSelected[index].unitPrice = 0;
            // CommonMethods.unformatNumericField(fieldName);
            break;
          }
          case 'extPrice': {
            this.worksSelected[index].extPrice = 0;
            // CommonMethods.unformatNumericField(fieldName);
            break;
          }
        }
        break;
      }
    }
  }
  // @Deprecated (JLG - 2026-03-03)
  formatCurrencyField(fieldType: string, fieldOrig: string, fieldName: string, index: number): void {
    const input = document.getElementById(fieldName) as HTMLInputElement;
    const value = input.value.replace(/[^\d,.]/g, ''); // Supprime tout sauf chiffres et virgule
    if (value === '') {
      return ;
    }
    const valueArg = parseFloat(value);
    switch (fieldType) {
      case 'supplies': {
        switch (fieldOrig) {
          case 'unitPrice': {
            this.suppliesList[index].unitPrice = valueArg;
            CommonMethods.formatNumericField(fieldName, this._translate, 
              ['currency', this.numberFormat.locale, this.numberFormat.currency, 'symbol']);
            break;
          }
          case 'extPrice': {
            this.suppliesList[index].extPrice = valueArg;
            CommonMethods.formatNumericField(fieldName, this._translate, 
              ['currency', this.numberFormat.locale, this.numberFormat.currency, 'symbol']);
            break;
          }
        }
        break;
      }
      case 'services': {
        switch (fieldOrig) {
          case 'unitPrice': {
            this.servicesList[index].unitPrice = valueArg;
            CommonMethods.formatNumericField(fieldName, this._translate, 
              ['currency', this.numberFormat.locale, this.numberFormat.currency, 'symbol']);
            break;
          }
          case 'extPrice': {
            this.servicesList[index].extPrice = valueArg;
            CommonMethods.formatNumericField(fieldName, this._translate, 
              ['currency', this.numberFormat.locale, this.numberFormat.currency, 'symbol']);
            break;
          }
        }
        break;
      }
      case 'works': {
        switch (fieldOrig) {
          case 'unitPrice': {
            this.worksSelected[index].unitPrice = valueArg;
            CommonMethods.formatNumericField(fieldName, this._translate, 
              ['currency', this.numberFormat.locale, this.numberFormat.currency, 'symbol']);
            break;
          }
          case 'extPrice': {
            this.worksSelected[index].extPrice = valueArg;
            CommonMethods.formatNumericField(fieldName, this._translate, 
              ['currency', this.numberFormat.locale, this.numberFormat.currency, 'symbol']);
            break;
          }
        }
        break;
      }
    }

  }
  registerActions(_orig: string, forcedInput: boolean) {
    
    if (_orig === 'works') {
      for (const workCur of this.worksSelected) {
        workCur.available = true;
      }
      if (JSON.stringify(this.worksSelectedCache)  === JSON.stringify(this.worksSelected) ) {
        return;
      }
    }
    if (_orig === 'services') {
      for (const serviceCur of this.servicesList) {
        serviceCur.available = true;
      }
      if (JSON.stringify(this.servicesListCache) === JSON.stringify(this.servicesList) ) {
        return;
      }
    }
    if (_orig === 'supplies&parts') {
      if (JSON.stringify(this.suppliesListCache) === JSON.stringify(this.suppliesList) ) {
        this.suppliesListCache = JSON.parse(JSON.stringify(this.suppliesList));
        return;
      }
    }
    const tasksActionsContent: TasksActionsContentModel = {
      supplies: this.suppliesList,
      works: this.worksSelected,
      services: this.servicesList,
      rowTask: (this.rowTask ? this.rowTask : 0)
    };

    if (this.isLoaded || forcedInput) {
      this._wksCentralService.taskWksEvent.emit({
        orig: _orig,
        rowTask: this.rowTask,
        todo: 'changeValuesTask',
        content: tasksActionsContent
      });
      this._wksCentralService.taskWksEvent.emit({
        orig: _orig,
        rowTask: this.rowTask,
        todo: 'changeValuesWorks',
        content: tasksActionsContent
      });
    }
    let inputFailed = false;
    if (this.optionItem === 'works' ) {
      inputFailed = false;
      for (const workCur of this.worksSelected) {
        if (workCur.quantity === undefined || workCur.quantity === null || workCur.quantity === 0) {
          inputFailed = true;
        }
        if (workCur.unitPrice === undefined || workCur.unitPrice === null || workCur.unitPrice === 0) {
          inputFailed = true;
        }
        /*
        if (workCur.unitPrice === undefined || workCur.unitPrice === null || workCur.unitPrice === 0) {
          inputFailed = true;
        }
        if (workCur.extPrice === undefined || workCur.extPrice === null || workCur.extPrice === 0) {
          inputFailed = true;
        }
          */
      }
      this.statutCur({
        subject: 'works',
        failed: inputFailed
      });
    } else if (this.optionItem === 'services' ) {
      inputFailed = false;
      for (const serviceCur of this.servicesList) {
        if (serviceCur.quantity === undefined || serviceCur.quantity === null || serviceCur.quantity === 0) {
          inputFailed = true;
        }
        if (serviceCur.unitPrice === undefined || serviceCur.unitPrice === null || serviceCur.unitPrice === 0) {
          inputFailed = true;
        }
        /*
        if (serviceCur.unitPrice === undefined || serviceCur.unitPrice === null || serviceCur.unitPrice === 0) {
          inputFailed = true;
        }
        if (serviceCur.extPrice === undefined || serviceCur.extPrice === null || serviceCur.extPrice === 0) {
          inputFailed = true;
        }
          */
      }
      this.statutCur({
        subject: 'services',
        failed: inputFailed
      });
    } else {
      inputFailed = false;
      for (const supplieCur of this.suppliesList) {
        if (supplieCur.actionTask === undefined || supplieCur.actionTask === '') {
          inputFailed = true;
        }
        if (supplieCur.quantity === undefined || supplieCur.quantity === null || supplieCur.quantity === 0) {
          inputFailed = true;
        }
        if (supplieCur.unitPrice === undefined || supplieCur.unitPrice === null || supplieCur.unitPrice === 0) {
          inputFailed = true;
        }
        /*
        if (supplieCur.unitPrice === undefined || supplieCur.unitPrice === null || supplieCur.unitPrice === 0) {
          inputFailed = true;
        }
        if (supplieCur.extPrice === undefined || supplieCur.extPrice === null || supplieCur.extPrice === 0) {
          inputFailed = true;
        }
          */
      }
      this.statutCur({
        subject: 'partsSupplies',
        failed: inputFailed
      });
    }

  }
  // serchain parsts & supplies
  openSearchModal(typeSearchOpt: string) {
    this.dataUpstream = {
      equipType: '',
      equipBrand: '',
      equipModel: '',
    };
    this.typeSearch = typeSearchOpt,
    this.openModal(this.searchModal);
  }
  // modal action ref
  /*
  openActionModal() {
    this.dataUpstream = {
      equipType: '',
      equipBrand: '',
      equipModel: '',
    };
    this.openModal(this.actionModal);
  }
    */
  openModal(template: TemplateRef<any>) {

    // this.modalText = [docCur.docName];
    this.modalRef = this.modalService.show(template, this.configModal);
  }
  closeModal() {

    this.modalRef.hide();
    this.modalRef = undefined;
    // this.modalService.hide();
  }
  statutCur(event: EventStatutCur): void  {
    if (!this.isReadOnly) {
      this.dataOut.emit(event);
    }
  }
}
